import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'frageboegen-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss']
})
export class LicenseComponent implements OnInit {

  public licenseText: string;

  constructor(private readonly activatedRoute: ActivatedRoute) {
  }

  public ngOnInit(): void {
    this.licenseText = this.activatedRoute.snapshot.data.licenseText;
  }
}
